exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".divBox .selWidth[data-v-56c33dca]{width:200px}.divBox .table[data-v-56c33dca]{margin-top:20px}.divBox .refund-preview p[data-v-56c33dca]{margin:0 0 12px}", ""]);

// exports
